
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos/sections/[sectionSlug]",
      function () {
        return require("private-next-pages/pos/sections/[sectionSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos/sections/[sectionSlug]"])
      });
    }
  